<section i18n-aria-label="@@hermes.notifications" aria-label="Notifications">
    <div class="banner-message">
        <p [attr.role]="'status'" [attr.data-testid]="'banner-message'">
            <ng-container i18n="@@hermes-global-translations.facet-available-banner-angular">
                Hold your horses! The object you desire is not available, but this page houses many other treasures
            </ng-container>

            <button (click)="closeBannerFacet.emit()" (keypress.enter)="closeBannerFacet.emit()" class="close-icon">
                <span hSrOnlyNoSnippet i18n="@@hermes_global.close-info-banner-accessibility">
                    Close the notification
                </span>
                <h-svg-icon [name]="'cross'"></h-svg-icon>
            </button>
        </p>
    </div>
</section>
